export default {
      id: "filter-usage",
      viewBox: "0 0 16 20",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#filter",
      toString: function () {
        return this.url;
      }
    }